import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './app.vue'
import VueMeta from 'vue-meta'

import information from './configurables/information'

import ContentTakenpakket from './components/content-takenpakket.vue'
import ContentDiensten from './components/content-diensten.vue'
import ContentDownloads from './components/content-downloads.vue'
import ContentHome from './components/content-home.vue'
import ContentContact from './components/content-contact.vue'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.prototype.$scrollToTop = () => window.scrollTo(0,0)

const routes = [
  { path: '/', name: 'home', component: ContentHome, meta: {title: "Home"}},
  { path: '/takenpakket', name: 'takenpakket', component: ContentTakenpakket, meta: {title: "Takenpakket"} },
  { path: '/diensten', name: 'diensten', component: ContentDiensten, meta: {title: "Diensten"} },
  { path: '/downloads', name: 'downloads', component: ContentDownloads, meta: {title: "Downloads"} },
  { path: '/contact', name: 'contact', component: ContentContact, meta: {title: "Contact"} },
]

routes.forEach(r => r.meta.title = r.meta.title.concat(` - ${information.title}`))


const router = new VueRouter({
  routes, // short for `routes: routes`
  mode: 'history'
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

const faviconURL = require('./assets/favicon.ico');

const Site = new Vue({
  router,
  metaInfo()  {
    return {
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1, user-scalable=0' },
        { name: 'description', content: 'Rojeca ADR Advies is uw veiligheidsadviseur voor het transport, de opslag en de verwerking van gevaarlijke stoffen.' },
      ],
      link: [
        {rel: "icon", href: faviconURL, type: "image/x-icon"},
      ]
    }
  },
  render: h => h(App)
})

Site.$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js